import React$1 from 'react';
import styles from './Title.scss.js';
function Title(_ref) {
  let {
    title,
    subtitle,
    titleMetadata,
    thumbnail
  } = _ref;
  const titleMarkup = title ? /*#__PURE__*/React$1.createElement("h1", {
    className: styles.Title
  }, title) : null;
  const titleMetadataMarkup = titleMetadata ? /*#__PURE__*/React$1.createElement("div", {
    className: styles.TitleMetadata
  }, titleMetadata) : null;
  const wrappedTitleMarkup = titleMetadata ? /*#__PURE__*/React$1.createElement("div", {
    className: styles.TitleWithMetadataWrapper
  }, titleMarkup, titleMetadataMarkup) : titleMarkup;
  const subtitleMarkup = subtitle ? /*#__PURE__*/React$1.createElement("div", {
    className: styles.SubTitle
  }, /*#__PURE__*/React$1.createElement("p", null, subtitle)) : null;
  const thumbnailMarkup = thumbnail ? /*#__PURE__*/React$1.createElement("div", null, thumbnail) : null;
  const pageTitleClassName = thumbnail ? styles.hasThumbnail : undefined;
  return /*#__PURE__*/React$1.createElement("div", {
    className: pageTitleClassName
  }, thumbnailMarkup, /*#__PURE__*/React$1.createElement("div", {
    className: styles.TitleAndSubtitleWrapper
  }, wrappedTitleMarkup, subtitleMarkup));
}
export { Title };